export enum ActionType {
  CHALLENGE = "CHALLENGE",
  DEVICE_DATA_COLLECTION = "DEVICE_DATA_COLLECTION",
}

export interface ClientAction {
  url: string;
  encoded_method_data: string;
  action_type: ActionType;
  transaction_id: string;
  challenge_provider_token?: string;
}

export interface PaymentMethodOptions {
  transaction_type?: string;
  usage?: string;
  cof_type?: string;
}

export interface PaymentIntentError {
  type: string;
  code?: string;
  text?: string;
}

export interface PaymentIntent {
  id: string;
  status: string;
  capture_method: string;
  authentication_id?: string;
  next_action?: ClientAction;
  payment_method_options?: PaymentMethodOptions;
  error?: PaymentIntentError;
  last_update: number;
}

/**
 * check the payment intent has settled — i.e. status is no longer "PROCESSING",
 * and not "REQUIRES_CAPTURE" with capture_method "AUTO" (that combination auto-captures
 * asynchronously and is still in flight). Any other status, including "REQUIRES_CAPTURE"
 * with capture_method "MANUAL", counts as settled.
 */
export function isSettled(intent: PaymentIntent): boolean {
  const isProcessing = intent.status === "PROCESSING";
  const isAutoCapturing = intent.status === "REQUIRES_CAPTURE" && intent.capture_method === "AUTO";
  return !isProcessing && !isAutoCapturing;
}

/** True when the merchant set an MIT type; AD_HOC is a customer-initiated card on file. */
export function isMitCofType(intent: PaymentIntent): boolean {
  const cofType = intent.payment_method_options?.cof_type;
  return typeof cofType === "string" && cofType !== "AD_HOC";
}

export function isPaid(intent: PaymentIntent): boolean {
  return (
    intent.status === "SUCCEEDED" ||
    (intent.status === "REQUIRES_CAPTURE" && intent.capture_method === "MANUAL")
  );
}
